import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ContextProvider from "./Context";
import reportWebVitals from "./reportWebVitals";
import { ConfigProvider } from "antd";
import theme from "./Utils/theme";
import validation from "./Utils/validation";
import "./Assets/styles/index.scss";
import "antd/dist/reset.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ConfigProvider
    theme={{ token: theme }}
    form={{ validateMessages: validation }}
  >
    <ContextProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
      <ToastContainer rtl={true} />
    </ContextProvider>
  </ConfigProvider>
);

// const dl = ReactDOM.createRoot(document.getElementById("dl"));
// dl.render();

reportWebVitals();
